module.exports = __webpack_public_path__ + "static/media/LK__View Trend.17267c5d.svg";